import React, { useEffect, useRef, useState } from 'react'
import { ModalForAll } from '../global/ModalForAll';
import Select from "react-select";
import AddIconMI from "@mui/icons-material/AddCircleOutlineRounded";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from '@mui/icons-material/Add';
import ArrowDropDownCircleOutlinedIcon from '@mui/icons-material/ArrowDropDownCircleOutlined';
import { returnFullURL } from '../../utils/goblaFunctions';
import styled from 'styled-components';
import CallApi from '../../data/CallApi';

const customStyles = {
    container: (provided) => ({
        ...provided,
        width: '100%',
    }),
    control: (provided) => ({ //no se usa
        ...provided,
        width: '100%',
        height: '20px !important',
    }),
    valueContainer: (provided) => ({
        ...provided,
        color: '#000',
        textAlign: 'left',
        fontSize: '14px',
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#000',
    }),
    input: (provided) => ({
        ...provided,
        color: '#000',
        textAlign: 'left',
        fontSize: '14px',
    }),
    option: (provided, state) => ({
        ...provided,
        color: '#000', // color del texto
        backgroundColor: state.isFocused ? '#f0f0f0' : 'white', // opcional: resaltar al pasar mouse
        textAlign: 'left',
        fontSize: '14px',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#000',
    }),
    menu: (provided) => ({
        ...provided,
        zIndex: 9999, // para evitar que quede oculto si hay overflow
    }),
};

export const ModalHistory = ({
    listHistory,
    closeModalHistory,
    current_branch,
    updateProduct = (() => { })
}) => {

    const [stateRequest, setStateRequest] = useState(false);
    const [stateModals, setStateModals] = useState({
        descriptions: false,
        images: false
    });
    const refMain = useRef(null);
    const [lisConverted, setlisConverted] = useState({});
    const [objectsSelected, setObjectsSelected] = useState({});

    const loadSelected = ({ field = 'code', title = 'Codigo:', onlyFirst = false, placeholder = 'Selecciona un codigo', tabIndex = 0 }) => {
        const listField = lisConverted?.[field];
        if (!listField) return;
        return (
            <div>
                <label className='normal-black text-bold' htmlFor={field + "Product"}>{title}</label>

                <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <Select
                        name={field + "Product"}
                        options={listField}
                        value={objectsSelected?.[field]}
                        onChange={(event) => setObjectsSelected((current_object) => ({ ...current_object, [field]: event }))}
                        placeholder={placeholder}
                        styles={customStyles}
                        tabIndex={tabIndex}
                        isDisabled={onlyFirst}
                        isClearable={false}
                    />
                </div>
            </div>
        );
    }

    function handleListDescription(value = true) {
        setStateModals((current_obj) => ({ ...current_obj, descriptions: value }));
        handleModals(value);
    }

    function handleListImages(value = true) {
        setStateModals((current_obj) => ({ ...current_obj, images: value }));
        handleModals(value);
    }

    const handleModals = (value) => refMain?.current && (refMain.current.style.display = !value ? 'flex' : 'none');

    function changeVersionsDescription(index) {
        setObjectsSelected((current_obj) => ({ ...current_obj, description: lisConverted?.description?.[index] }));
        handleListDescription(false);
    }

    function changeVersionsImage(index) {
        setObjectsSelected((current_obj) => ({ ...current_obj, images: lisConverted?.images?.[index] }));
        handleListImages(false);
    }

    async function saveChanges(e) {
        e.preventDefault();

        const bodyRequest = {
            key_product: objectsSelected?.key_product,
            name: objectsSelected?.name.value,
            price: objectsSelected?.price.value,
            price2: objectsSelected?.price2.value,
            price3: objectsSelected?.price3.value,
            purchase_price: objectsSelected?.purchase_price.value,
            proveedor: objectsSelected?.proveedor.value,
            ciudad: objectsSelected?.ciudad.value,
            categoria: objectsSelected?.categoria.value,
            wholesale: objectsSelected?.wholesale.value,
            description: objectsSelected?.description,
            images: objectsSelected?.images,
        };
        
        try {
            setStateRequest(true);
            const fetchUpdateProduct = await CallApi({
                url: `api/company/product/restore?key_branch=${current_branch}`,
                method: 'put',
                body: bodyRequest,
                showMessage: true
            });

            if (fetchUpdateProduct?.code != 200) return;

            updateProduct({
                key_product: objectsSelected?.key_product,
                name: objectsSelected?.name.value,
                description: objectsSelected?.description,
                code: objectsSelected?.code.value,
                price: objectsSelected?.price.value,
                price2: objectsSelected?.price2.value,
                price3: objectsSelected?.price3.value,
                purchase_price: objectsSelected?.purchase_price.value,
                stock: objectsSelected?.stock.value,
                supplier: objectsSelected?.proveedor.label,
                locality: objectsSelected?.ciudad.label,
                brand: objectsSelected?.marca.value,
                wholesale: objectsSelected?.wholesale.value,
                category: objectsSelected?.categoria.label,
                fullName: "Indefinido...",
                last_update: objectsSelected?.last_update,
                state: objectsSelected?.state,
                images: objectsSelected?.images,
                id: objectsSelected?.key_product
            });
            closeModalHistory();
            setlisConverted({});
            setObjectsSelected({});
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setStateRequest(false);
        }
    }

    useEffect(() => {
        if (Array.from(listHistory).length == 0) return;

        function transformHistory(list) {
            // Invertir para procesar desde la última fila a la primera
            const reversed = [...list].reverse();

            // Función para eliminar duplicados basados en value
            const uniqueByValue = (array) => {
                const seen = new Set();
                return array.filter(item => {
                    if (seen.has(item.value)) return false;
                    seen.add(item.value);
                    return true;
                });
            };

            return {
                key_product: uniqueByValue(
                    reversed.map(i => i.key_product)
                ),

                name: uniqueByValue(
                    reversed.map(i => ({ label: i.name, value: i.name }))
                ),

                description: (() => {
                    const seen = new Set();
                    return reversed.filter(i => {
                        const key = JSON.stringify(i.description);
                        if (seen.has(key)) return false;
                        seen.add(key);
                        return true;
                    }).map(i => i.description);
                })(),

                images: (() => {
                    const vistas = new Set();
                    const resultado = [];
                    const listaImg = reversed ?? [];

                    for (const lista of listaImg) {
                        const clave = JSON.stringify(lista?.images);

                        if (!vistas.has(clave)) {
                            vistas.add(clave);
                            resultado.push(lista?.images);
                        }
                    }

                    return resultado;
                })(),

                code: uniqueByValue(
                    reversed.map(i => ({ label: i.code, value: i.code }))
                ),

                price: uniqueByValue(
                    reversed.map(i => ({ label: i.price, value: i.price }))
                ),

                price2: uniqueByValue(
                    reversed.map(i => ({ label: i.price2, value: i.price2 }))
                ),

                price3: uniqueByValue(
                    reversed.map(i => ({ label: i.price3, value: i.price3 }))
                ),

                purchase_price: uniqueByValue(
                    reversed.map(i => ({ label: i.purchase_price, value: i.purchase_price }))
                ),

                stock: uniqueByValue(
                    reversed.map(i => ({ label: i.stock, value: i.stock }))
                ),

                proveedor: uniqueByValue(
                    reversed.map(i => ({ label: i.p_name, value: i.p_id }))
                ),

                ciudad: uniqueByValue(
                    reversed.map(i => ({ label: i.t_name, value: i.t_id }))
                ),

                categoria: uniqueByValue(
                    reversed.map(i => ({ label: i.c_name, value: i.c_id }))
                ),

                marca: uniqueByValue(
                    reversed.map(i => ({ label: i.brand, value: i.brand }))
                ),

                wholesale: uniqueByValue(
                    reversed.map(i => ({ label: i.wholesale, value: i.wholesale }))
                ),

                last_update: uniqueByValue(
                    reversed.map(i => i.last_update)
                ),

                state: uniqueByValue(
                    reversed.map(i => i.state)
                )
            };
        }

        const newObject = transformHistory(listHistory);
        setlisConverted(newObject);

        const valuesSelected = Object.keys(newObject).reduce((acc, field) => {
            acc[field] = newObject[field][0];
            return acc;
        }, {});

        setObjectsSelected(valuesSelected);
    }, [listHistory])

    function closeModalMain() {
        setStateModals((current_obj) => {
            if (!current_obj.descriptions && !current_obj.images) closeModalHistory();
            return current_obj;
        })
    }
    // const DivStyles = styled.div`
    // display: flex;
    // flex-direction: column;
    // gap:10px;
    // padding:5px;
    // &:hover {
    //     background-color: #312e81;
    // }
    // `;
    if (Array.from(listHistory).length == 0) return;

    return (
        <>
            <ModalForAll stateModal={Array.from(listHistory).length > 1} setStateModal={closeModalMain}>
                <h3 className='font-h2' style={{ color: 'var(--theme-company)', display: 'flex', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
                    Restaurar Producto
                </h3>

                <div className='body-product-form'>
                    <div className='content-inputs-bpf'>
                        {loadSelected({ field: 'code', title: 'Codigo', onlyFirst: true, placeholder: 'EAN-13', tabIndex: 0 })}
                        {loadSelected({ field: 'name', title: 'Nombre del producto', placeholder: 'Motor de agua...', tabIndex: 1 })}
                        {loadSelected({ field: 'ciudad', title: 'Ciudad', placeholder: 'Selecciona una ciudad...', tabIndex: 2 })}
                        {loadSelected({ field: 'purchase_price', title: 'Precio de compra', placeholder: '0.00', tabIndex: 3 })}
                        {loadSelected({ field: 'price', title: 'Precio de venta 1', placeholder: '0.00', tabIndex: 4 })}
                        {loadSelected({ field: 'price2', title: 'Precio de venta 2', placeholder: '0.00', tabIndex: 5 })}
                        {loadSelected({ field: 'price3', title: 'Precio de venta 3', placeholder: '0.00', tabIndex: 6 })}
                        {loadSelected({ field: 'wholesale', title: 'Precio por mayor', placeholder: '0.00', tabIndex: 7 })}
                        {loadSelected({ field: 'categoria', title: 'Categoría', placeholder: 'Selecciona una categoría', tabIndex: 8 })}
                        {loadSelected({ field: 'stock', onlyFirst: true, title: 'Stock', placeholder: '1', tabIndex: 9 })}
                        {loadSelected({ field: 'proveedor', title: 'Proveedor', placeholder: 'Selecciona un proveedor', tabIndex: 10 })}
                        {loadSelected({ field: 'marca', onlyFirst: true, title: 'Marca', placeholder: 'Selecciona una marca', tabIndex: 11 })}
                    </div>

                    <div>
                        <label className='label-form' style={{ display: 'flex', gap: '5px', position: 'relative', width: 'fit-content' }}>
                            Elige tu descripcion preferida

                            <button className='default-buttons' onClick={handleListDescription} key={'btn-handleDescription-' + objectsSelected?.key_product}>
                                <ArrowDropDownCircleOutlinedIcon style={{ color: '#2E7D32' }} />
                            </button>
                        </label>


                        <ul className='content-inputs-bpf list-descriptions-product'>
                            {
                                objectsSelected?.description && Object.entries(objectsSelected?.description ?? {}).map((field_value, index) => (
                                    <li style={{ cursor: 'pointer', padding: '8px', borderRadius: '10px', backgroundColor: 'var(--theme-main)' }}>
                                        <span><b>{field_value[0]}:</b>&nbsp;{field_value[1]}</span>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>

                    <div className='container-control-images'>
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', gap: '5px' }}>
                            <label className='label-form'>Elige tu listado de imágenes preferido</label>
                            <button className='default-buttons' onClick={handleListImages}>
                                <ArrowDropDownCircleOutlinedIcon style={{ color: '#2E7D32' }} />
                            </button>
                        </div>

                        <div className='control-images'>
                            {
                                objectsSelected?.images && objectsSelected.images.map((urls) => (
                                    <div
                                        style={{
                                            width: '100px',
                                            height: '100px',
                                            borderRadius: '15px',
                                            overflow: 'hidden',
                                            boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)',
                                            position: 'relative'
                                        }}
                                    >
                                        <img src={returnFullURL(urls, "picture")} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }} />
                                    </div>
                                ))
                            }
                        </div>
                    </div>


                    <div className='content-buttons'>
                        <button className='default-buttons form-buttons' style={{ backgroundColor: '#E62E2D' }} onClick={(event) => { event.preventDefault(); closeModalHistory(); }}>
                            Cancelar
                        </button>

                        <input type='button' className='default-buttons form-buttons' style={{ backgroundColor: '#3F77F3' }} value={stateRequest ? 'Actualizando...' : 'Actualizar'} onClick={saveChanges} disabled={stateRequest} />
                    </div>
                </div>


            </ModalForAll>

            <ModalForAll stateModal={stateModals.descriptions} setStateModal={handleListDescription}>
                {
                    Array.from(lisConverted?.description ?? []).length > 0 && lisConverted?.description.map((obj_description, indexMain) => (
                        <div className='recover-data-content'>
                            <ul className='content-inputs-bpf list-descriptions-product'>
                                {
                                    obj_description && Object.entries(obj_description ?? {}).map((field_value) => (
                                        <li style={{ cursor: 'pointer', padding: '8px', borderRadius: '10px', backgroundColor: 'var(--theme-main)' }}>
                                            <span><b>{field_value[0]}:</b>&nbsp;{field_value[1]}</span>
                                        </li>
                                    ))
                                }
                            </ul>

                            {
                                obj_description != objectsSelected?.description && (
                                    <button
                                        className='default-buttons rdc-button'
                                        style={{ height: 'min-content' }}
                                        onClick={() => changeVersionsDescription(indexMain)}
                                    >
                                        Seleccionar
                                    </button>
                                )
                            }
                        </div>
                    ))
                }

            </ModalForAll>

            <ModalForAll stateModal={stateModals.images} setStateModal={handleListImages}>
                <div className='search-body' style={{ gap: '20px' }}>
                    {
                        Array.from(lisConverted?.images ?? []).length > 0 && lisConverted?.images.map((obj_images, indexMain) => (
                            <div className='control-images' style={{ position: 'relative' }}>
                                {
                                    obj_images && obj_images.map((urls) => (
                                        <div
                                            style={{
                                                width: '150px',
                                                height: '150px',
                                                borderRadius: '15px',
                                                overflow: 'hidden',
                                                boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)',
                                                position: 'relative'
                                            }}
                                        >
                                            <img src={returnFullURL(urls, "picture")} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }} />
                                        </div>
                                    ))
                                }

                                {
                                    obj_images != objectsSelected?.images && (
                                        <button
                                            className='default-buttons rdc-button'
                                            style={{ height: 'min-content', backgroundColor: '#fff', border: '1.5px solid #000', color: '#000', bottom: '-10%' }}
                                            onClick={() => changeVersionsImage(indexMain)}
                                        >
                                            Seleccionar
                                        </button>
                                    )
                                }
                            </div>
                        ))
                    }
                </div>
            </ModalForAll>
        </>
    )
}
